import {
	getTablePriceRound,
	getTablePriceRoundWay,
	getTablePricesListsAverage,
	getTablePricesListsOperationType
} from 'actions'
import ConfirmModalNoButton from 'components/common/ConfirmModalNoButton'
import NotificationError from 'components/common/notificationsErrors'
import ProductImport from 'components/ProductImport'
import { Form, Formik, FormikProps } from 'formik'
import { getValidationSchema } from 'lib/FieldValidations'
import {
	ActionType,
	ConfirmType,
	IOptions,
	IPricesListsMassiveUpdateDiscountFormProps,
	IPricesListsMassiveUpdateDiscountFormState,
	ISelectListValueParam
} from 'models/PricesListsMassiveUpdate'
import React, { Component, Fragment } from 'react'
import { Alert, Button, Col, Row } from 'react-bootstrap'
import { TransProps, WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import _ from 'underscore'
import PricesListsMassiveUpdateDiscountFormField from './PricesListsMassiveUpdateDiscountFormFields'

export interface IReduxProps {
	getTablePriceRound: () => void
	getTablePriceRoundWay: () => void
	getTablePricesListsAverage: () => void
	getTablePricesListsOperationType: () => void
	priceRound: IOptions
	priceRoundWay: IOptions
	operationType: IOptions
	average: IOptions
}
class PricesListsMassiveUpdateDiscountForm extends Component<
	IPricesListsMassiveUpdateDiscountFormProps &
		TransProps &
		WithTranslation &
		IReduxProps,
	IPricesListsMassiveUpdateDiscountFormState
> {
	constructor(
		props: IPricesListsMassiveUpdateDiscountFormProps &
			TransProps &
			WithTranslation &
			IReduxProps
	) {
		super(props)
		this.state = {
			action: props.action.code === '1' ? ActionType.APPLY : ActionType.DELETE,
			showCancelModal: false,
			forma_red: '',
			redondeo: ''
		}
	}

	handleRedondeo = (value: ISelectListValueParam) => {
		this.setState({
			redondeo: value.codigo
		})
	}

	handleRedondeoChange = (value: String) => {
		const { priceRound } = this.props
		const optValue = _.find(priceRound?.lista, (opt) => opt.codigo === value)
		if (optValue) {
			this.handleRedondeo(optValue)
		}
	}

	handleFormaRedondeo = (value: ISelectListValueParam) => {
		this.setState({
			forma_red: value.codigo
		})
	}

	handleFormaRedondeoChange = (value: String) => {
		const { priceRoundWay } = this.props
		const optValue = _.find(priceRoundWay?.lista, (opt) => opt.codigo === value)
		if (optValue) {
			this.handleFormaRedondeo(optValue)
		}
	}

	componentDidMount = () => {
		this.props.getTablePriceRound()
		this.props.getTablePriceRoundWay()
		this.props.getTablePricesListsAverage()
		this.props.getTablePricesListsOperationType()
	}

	componentDidUpdate(prevProps: IPricesListsMassiveUpdateDiscountFormProps) {
		const { action } = this.props
		if (action !== prevProps.action) {
			this.setState({
				action: action.code === '1' ? ActionType.APPLY : ActionType.DELETE
			})
		}
	}

	handleCancelModal = (showCancelModal: boolean) => {
		this.setState({ showCancelModal: showCancelModal })
	}

	render() {
		const {
			t,
			fields,
			idOperacion,
			listsAutocomplete,
			handlePricesListsRecord,
			handleConfirmModal,
			handleSearchPricesLists,
			handleIsSearching,
			handleCancelRedirect,
			isSearching,
			showConfirmModal,
			errorMessage,
			lk_sel_list
		} = this.props

		const { action, showCancelModal, forma_red, redondeo } = this.state

		const initialValues = {
			idOperacion: idOperacion,
			lk_cod_prod: '',
			lk_categ_prod: '',
			lk_desc_prod: '',
			lk_sel_list: lk_sel_list,
			tipo_pc: '',
			pc_sum: 0,
			pc_nuevo: 0,
			opc_pc: '',
			redondeo: redondeo,
			cant_dec: 2,
			filtro_desc_prod: [''],
			filtro_desc_lp: [''],
			filtro_desc_catprod: [''],
			forma_red: forma_red
		}

		const validationSchema = fields.length
			? getValidationSchema(fields, t, [], [])
			: {}

		return (
			<Formik
				initialValues={initialValues}
				onSubmit={(values, actions) => {
					this.props.handlePricesListsApply(values)
				}}
				enableReinitialize={true}
				validationSchema={validationSchema}
			>
				{(props: FormikProps<any>) => (
					<Fragment>
						<Col sm={12}>
							<NotificationError
								errors={props.errors}
								touched={props.touched}
							/>
						</Col>
						<Col sm={12}>
							<Alert variant={'dark'}>
								<b>{t('CRUDS.general_use.discount')}</b>
							</Alert>
						</Col>
						<Form className="container-fluid">
							<Row className="row justify-content-md-center">
								<Col sm={8}>
									<Row>
										{!_.isEmpty(fields) &&
											_.map(fields, (field, index) => {
												return (
													<Col sm={4} key={index}>
														<PricesListsMassiveUpdateDiscountFormField
															field={field}
															formikProps={props}
															crudProps={this.props}
															initialValue={{}}
															listsAutocomplete={listsAutocomplete}
															handleSearchPricesLists={handleSearchPricesLists}
															handleIsSearching={handleIsSearching}
															isSearching={isSearching}
															handleFormaRedondeoChange={
																this.handleFormaRedondeoChange
															}
															handleRedondeoChange={this.handleRedondeoChange}
														/>
													</Col>
												)
											})}
									</Row>
								</Col>

								<Col sm={3}>
									<Row className="justify-content-center text-center">
										<div
											style={{
												minWidth: '145px',
												margin: '20px'
											}}
										>
											<ProductImport
												minWidth={'145px'}
												idOperacion={idOperacion}
											/>
										</div>

										<Button
											style={{ minWidth: '145px', margin: '20px' }}
											type={'submit'}
										>
											{t('Collection.form.buttons.apply')}
										</Button>
									</Row>
									<Row className="justify-content-center text-center">
										<Button
											style={{ minWidth: '145px', margin: '20px' }}
											type={'button'}
											onClick={() => {
												handlePricesListsRecord(ConfirmType.NO_CONFIRM, action)
											}}
										>
											{action === ActionType.APPLY
												? t('global.record')
												: t('global.delete')}
										</Button>
										<Button
											style={{ minWidth: '145px', margin: '20px' }}
											type={'button'}
											onClick={() => {
												this.handleCancelModal(true)
											}}
											variant="secondary"
										>
											{t('global.cancel')}
										</Button>
									</Row>

									<ConfirmModalNoButton
										modalTitle={t('CRUDS.modal.title_warning')}
										messageBody={errorMessage}
										showModal={showConfirmModal}
										handleCloseModal={() => handleConfirmModal(false)}
										handleCancelButton={() => {
											handleConfirmModal(false)
										}}
										handleSubmitButton={() => {
											handlePricesListsRecord(ConfirmType.CONFIRM, action)
											handleConfirmModal(false)
										}}
									/>

									<ConfirmModalNoButton
										modalTitle={t('CRUDS.modal.title_warning')}
										messageBody={t('global.warning_cancel_message')}
										showModal={showCancelModal}
										handleCloseModal={() => this.handleCancelModal(false)}
										handleCancelButton={() => {
											this.handleCancelModal(false)
										}}
										handleSubmitButton={() => {
											handleCancelRedirect()
											this.handleCancelModal(false)
										}}
										labelSubmitButton={t('global.accept')}
										labelCancelButtonModal={t('global.return_button')}
									/>
								</Col>
							</Row>
						</Form>
					</Fragment>
				)}
			</Formik>
		)
	}
}
const mapStateToProps = ({ tableCalls }: any) => {
	const { priceRound, priceRoundWay, operationType, average } = tableCalls
	return {
		priceRound,
		priceRoundWay,
		operationType,
		average
	}
}

const connectForm = connect(mapStateToProps, {
	getTablePriceRound,
	getTablePriceRoundWay,
	getTablePricesListsOperationType,
	getTablePricesListsAverage
})(PricesListsMassiveUpdateDiscountForm)

export default withTranslation()(connectForm)
